import React from "react";
import IconTextToolTip from "../icons/IconTextToolTip";
import IconNewsletterSubmit from "../icons/IconNewsletterSubmit";
import {graphql, useStaticQuery} from "gatsby";
import validator from "validator";
const Newsletter = () => {
    const {allWp} = useStaticQuery(graphql`
		query NewsletterSection {
			allWp {
				nodes {
					newsletterSection {
						acfNewsletterSection {
							showSection
							description
							title
						}
					}
				}
			}
		}
	`);

    const settings = allWp?.nodes?.[0]?.newsletterSection?.acfNewsletterSection ?? {};

    if (!settings.showSection || !settings.title) {
        return null;
    }

    const sendRequest = async () => {
        const email = document.getElementById('newsletter-email').value
        document.getElementById('newsletter__alert').classList.remove('show')
        document.getElementById('newsletter__alert').classList.remove('error')
        if(email.length){
            if(validator.isEmail(email)){
                try {
                    await fetch(window.location.origin + '/wp-json/subscriptions/create', {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({email: email})
                    })
                        .then(response => response.json())
                        .then(result => {
                            if(result.error && result.error === "Email already subscribed"){
                                document.getElementById('newsletter__alert').innerHTML = "Email are already subscribed"
                                document.getElementById('newsletter__alert').classList.add('error')
                                document.getElementById('newsletter__alert').classList.add('show')
                                setTimeout(()=>{
                                    document.getElementById('newsletter__alert').classList.remove('show')
                                },7000)
                            }else{
                                document.getElementById('newsletter__alert').innerHTML = "You have successfully subscribed"
                                document.getElementById('newsletter-email').value = ""
                                document.getElementById('newsletter__alert').classList.add('show')
                                setTimeout(()=>{
                                    document.getElementById('newsletter__alert').classList.remove('show')
                                },7000)
                            }

                        })
                }catch (e){
                    console.log(e);
                }

            }else{
                document.getElementById('newsletter__alert').innerHTML = "Incorrect email"
                document.getElementById('newsletter__alert').classList.add('error')
                document.getElementById('newsletter__alert').classList.add('show')
                setTimeout(()=>{
                    document.getElementById('newsletter__alert').classList.remove('show')
                },7000)
            }

        }else{
            document.getElementById('newsletter__alert').innerHTML = "Email is required !"
            document.getElementById('newsletter__alert').classList.add('show')
            document.getElementById('newsletter__alert').classList.add('error')
            setTimeout(()=>{
                document.getElementById('newsletter__alert').classList.remove('show')
            },7000)
        }

    }

    return (
        <div className="newsletter container container--medium">
            <div className="newsletter__wrapper">
                <div className="newsletter__content">
                    <p className="newsletter__title">
						<span className="newsletter__content-icon">
							<IconTextToolTip/>
						</span>

                        {settings.title}
                    </p>

                    {Boolean(settings.description) && (
                        <p className="newsletter__text">
                            {settings.description}
                        </p>
                    )}
                </div>

                <div className="newsletter__mail">
                    <form>
                        <div className="newsletter__input-row">
                            <label htmlFor="newsletter-email" className="visually-hidden">Enter your email</label>
                            <input id="newsletter-email" type="email" className="newsletter__input"
                                   placeholder="Enter your email" required/>

                            <button className="newsletter__submit" type="button" onClick={sendRequest}
                                    aria-label="Submit newsletter form">
                                <IconNewsletterSubmit/>
                            </button>
                        </div>
                    </form>
                    <div id='newsletter__alert' className="newsletter__message"></div>
                </div>
            </div>
        </div>
    );
}

export default Newsletter;
